<script>
  import { createEventDispatcher } from "svelte";
  import TimeRangePicker from "./TimeRangePicker.svelte";
  import {External, M} from "../external";

  export let period = {
    label: M.ALL_TIME_FILTER,
    id: "all",
    from: null,
    to: null
  };
  export let showPeriods = ['today', 'yesterday', '7-days', '14-days', 'month', 'all', 'custom'];

  const dispatch = createEventDispatcher();

  let onChange = () => {
    dispatch("change", {
      period: period
    });
  };

  let onDateChange = (event) => {
    External.Tools.showFloatingPopup({
      markup: '<div class="col20 f-left bound-popup"></div>',
      width: 250,
      target: External.$(event.target),
      customClass: "floating-popup-list",
      action: {
        onShow: function (popup, ui) {
          let component = new TimeRangePicker({
            target: ui.find(".bound-popup")[0],
            props: {
              selected: period,
              showPeriods: showPeriods,
              change: function (timeRange) {
                period = timeRange;
                onChange();
                popup.close();
              }
            }
          });
          popup.component = component;
        },
        onHide: function (popup) {
          if (popup.component) {
            popup.component.$destroy();
            popup.component = null;
          }
        }
      }
    });
  };
</script>

<div class="custom-dropdown">
  <div class="flex align-center custom-dropdown-button circle-effect" on:click={(ev) => onDateChange(ev)}>
    <span class="material-icons date-range-icon"> date_range </span>
    {period.label} <span class="material-icons"> keyboard_arrow_down </span>
  </div>
</div>
